import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  QueryList,
} from "@angular/core";
import {
  FlexLayoutModule,
  MediaObserver,
  MediaChange,
} from "@angular/flex-layout";
import { Subscriber, Subscription } from "rxjs";
import { AlarmasService } from "../../services/alarmas/alarmas.service";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import * as _ from "lodash";
import { MatDialog } from "@angular/material/dialog";

import { ToastService } from "src/app/services/toast/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { LoginService } from "src/app/services/login/login.service";
import { TundishService } from "src/app/services/tundish/tundish.service";
import { IncidentsService } from "src/app/services/incidents/incidents.service";

import { GetDatePipe } from "src/app/pipes/pipes/pipe-date.pipe";
import { ActivatedRoute } from "@angular/router";
import { ModalComponent } from "src/app/components/modal/modal.component";
import { endsWith, sampleSize } from "lodash";
import { TundishModalComponent } from "./modal/tundish-modal.component";
import { T } from "@angular/cdk/keycodes";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-tundish",
  templateUrl: "./tundish.component.html",
  styleUrls: ["./tundish.component.scss"],
  providers: [GetDatePipe],
})
export class TundishComponent implements OnInit {
  formMode = "";
  isAdmin = false;
  loadingText = "LOADING.ALARMAS";
  loading = false;

  mobileMode: boolean = false;
  private mediaSub: Subscription;
  userId: string;
  filter = "";
  currentTundishCampaign: string;

  displayedColumnsTundishConsumptions: string[];
  dataSourceTundishConsumptionsSimple: MatTableDataSource<any> =
    new MatTableDataSource([]);
  displayedColumnsTundishOperations: string[];
  dataSourceTundishOperationsSimple: MatTableDataSource<any> =
    new MatTableDataSource([]);
  displayedColumnsTundishCampaigns: string[];
  dataSourceTundishCampaignsSimple: MatTableDataSource<any> =
    new MatTableDataSource([]);
  displayedColumnsAlarms: string[];
  dataSourceAlarms: any;

  alarmsByTundishCampaign: any[];
  alarmsByTundishOperations: any[];

  tundishDevices: any[] = [];
  tundishSelected: any;

  collectionNameCampaigns = "campaigns";
  collectionNameConsumptions = "consumptions";
  collectionNameIntervals = "9a72b49a-82ff-4406-89c8-b8e21d5ddc11";
  collectionNameSubintervals = "f05ec735-1752-4926-9cda-aa546fa2add7";
  colmagDispUuid = "00099989-999b-4a5e-9591-8be02382de8e";

  nextCampaignName: any;

  @ViewChild("operationsTable") operationsTableSimple: MatTable<any>;
  @ViewChild("campaignsTable") campaignsTableSimple: MatTable<any>;
  @ViewChild("consumptionsTable") consumptionsTableSimple: MatTable<any>;
  @ViewChild("campaignsPaginator") campaignsPaginatorSimple: MatPaginator;
  @ViewChild("operationsPaginator") operationsPaginatorSimple: MatPaginator;
  @ViewChild("consumptionsPaginator") consumptionsPaginatorSimple: MatPaginator;

  // Row remarking table
  highlightedRows = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private mediaObserver: MediaObserver,
    private fb: FormBuilder,
    private toastr: ToastService,
    private translate: TranslateService,
    private loginService: LoginService,
    private tundishService: TundishService,
    private incidentsService: IncidentsService,
    public dialog: MatDialog,
    private getDatePipe: GetDatePipe,
    private route: ActivatedRoute
  ) {
    this.isAdminUser();
  }

  isAdminUser() {
    if (this.loginService.currentUserValue.rol.includes("magna_admin")) {
      this.userId = this.loginService.currentUserValue.uuid;
      this.isAdmin = true;
    }
  }

  ngOnInit() {
    this.filter = this.route.snapshot.paramMap.get("filter");

    this.mediaSub = this.mediaObserver.media$.subscribe(
      (change: MediaChange) => {
        if (change.mqAlias == "xs" || change.mqAlias == "sm") {
          this.mobileMode = true;
        } else {
          this.mobileMode = false;
        }
      }
    );

    this.userId = this.loginService.currentUserValue.uuid;
    this.isAdminUser();

    this.displayedColumnsTundishOperations = [
      "uuid",
      "inicio",
      "fin",
      "duracion",
      "arena",
      "silicato",
      "catalizador",
      "estado",
      "consumos",
      "visualizar",
      "acciones",
    ];
    this.displayedColumnsTundishCampaigns = [
      "uuid",
      "campaña",
      "inicio",
      "fin",
      "duracion",
      "estado",
      "visualizar",
      "acciones",
    ];
    this.displayedColumnsTundishConsumptions = [
      "uuid",
      "fecha",
      "consumo",
      "coladas",
      "acciones",
    ];
    this.displayedColumnsAlarms = ["gunning", "alarma", "timestamp"];

    this.doRetrieveTundish();
  }

  ngAfterInit() {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.mediaSub.unsubscribe();
  }

  onTabClick(event): void {
    this.dialog.open(TundishModalComponent, {
      width: "25%",
      data: {
        title: "Cargando Información de la " + event.tab.textLabel + "...",
        id: -2,
        content: "Cargando información...",
        option: -2,
        wait: true,
        type: 0,
        admin: this.isAdmin,
      },
    });
    setTimeout(() => {
      this.doRetrieveTundishCampaignsByTundish(event.tab.ariaLabel);
      this.dialog.closeAll();
    }, 3000);
  }

  doRetrieveTundish(): void {
    this.tundishService.getTundishTypeDevices().subscribe(
      (data) => {
        console.log("findUsuarios -> ", data);
        if (data.data.findUsuarios.length > 0) {
          for (let i = 0; i < data.data.findUsuarios.length; i++) {
            let usuario = data.data.findUsuarios[i];
            if (usuario.uuid == this.userId) {
              for (let j = 0; j < usuario.dispositivos.length; j++) {
                let disp = data.data.findUsuarios[i].dispositivos[j];
                if (disp.nombre.includes("und")) {
                  this.tundishDevices.push({ ...disp });
                }
              }
            }
          }
          // Retrieve last closed work interval (we set disp as null)
          this.tundishService
            .getOperationsByTundish(this.collectionNameSubintervals, null)
            .subscribe(
              (data) => {
                let works = [...data.data.findIntervals];
                if (works.length > 0) {
                  for (let i = 0; i < this.tundishDevices.length; i++) {
                    if (works[0].disp == this.tundishDevices[i].uuid) {
                      this.tundishDevices[i].active = true;
                    } else this.tundishDevices[i].active = false;
                  }
                }
              },
              (err) => {
                console.log(err);
              }
            );
          // Retrieve data from the firts tundish of the array
          this.doRetrieveTundishCampaignsByTundish(this.tundishDevices[0].uuid);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doObtainCurrentTundishCampaign(data): string {
    let currentTundishCampaign;
    for (let i = 0; i < data.length; i++) {
      if (data[i].estado == "EN CURSO") currentTundishCampaign = data[i]._id;
    }
    return currentTundishCampaign;
  }

  doRetrieveTundishCampaignsByTundish(uuidTund): void {
    console.log(
      "Retrieving Campaign and Operation Data from Tundish " + uuidTund
    );
    // Cargamos tabla de Consumos
    // Cargamos tabla de Campañas
    this.tundishService
      .getConsumptionsByTundish(this.collectionNameConsumptions, uuidTund)
      .subscribe(
        (data) => {
          let consumptions = data.data.findConsumptionsByDisp;
          let paginator = this.consumptionsPaginatorSimple;
          console.log("Consumptions: ", consumptions);
          this.dataSourceTundishConsumptionsSimple.data = consumptions;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = consumptions.length;
          this.dataSourceTundishConsumptionsSimple.paginator = paginator;
        },
        (err) => {
          console.log(err);
        }
      );
    // Cargamos tabla de Campañas
    this.tundishService
      .getCampaignsByTundish(this.collectionNameCampaigns, uuidTund)
      .subscribe(
        (data) => {
          let campaigns = data.data.findCampaignsByDisp;
          let paginator = this.campaignsPaginatorSimple;
          console.log("Campaigns: ", campaigns);
          this.dataSourceTundishCampaignsSimple.data = campaigns;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = campaigns.length;
          this.dataSourceTundishCampaignsSimple.paginator = paginator;
        },
        (err) => {
          console.log(err);
        }
      );
    // Cargamos tabla de Operaciones
    this.tundishService
      .getOperationsByTundish(this.collectionNameIntervals, uuidTund)
      .subscribe(
        (data) => {
          let operations = data.data.findIntervals;
          let paginator = this.operationsPaginatorSimple;
          console.log("Operations: ", data.data.findIntervals);
          this.dataSourceTundishOperationsSimple.data = operations;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = operations.length;
          this.dataSourceTundishOperationsSimple.paginator = paginator;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveTundishOperationsByCampaign(uuidCampaign, uuidTund, index): void {
    this.tundishService
      .getCampaignById(this.collectionNameCampaigns, uuidCampaign)
      .subscribe(
        (data) => {
          let campaign = data.data.findCampaignById;
          this.tundishService
            .getOperationsByTundishBetweenDates(
              this.collectionNameIntervals,
              uuidTund,
              campaign.inicio,
              campaign.fin
            )
            .subscribe(
              (data) => {
                let paginator = this.operationsPaginatorSimple;
                let operations = data.data.findIntervalsBetweenDates;
                console.log("Operations: ", operations);
                this.dataSourceTundishOperationsSimple.data = operations;
                paginator.pageSize = 5;
                paginator.pageIndex = 0;
                paginator.length = operations.length;
                this.dataSourceTundishOperationsSimple.paginator = paginator;
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveTundishOperationMetadataById(id, option, type) {
    console.log(this.tundishDevices);
    this.tundishService
      .getOperationById(this.collectionNameIntervals, id)
      .subscribe(
        (data) => {
          let operation = data.data.findIntervalById;
          let start = operation.inicio;
          let end = operation.fin;
          let uuid = operation._id;
          let disp = operation.disp;
          let arena = operation.campos.arena.kilos;
          let catalizador = operation.campos.catalizador.litros;
          let silicato = operation.campos.silicato.litros;
          let dispNumber = this.doGetTundishNumber(disp);
          this.dialog
            .open(TundishModalComponent, {
              width: "25%",
              id: "editOperationDialog",
              data: {
                title: "Operación de Tundish: Editar/Reasignar",
                id: id,
                content: "",
                option: option,
                metadata: {
                  start: start,
                  end: end,
                  uuid: uuid,
                  disp: disp,
                  num: dispNumber,
                  arena: this.doRoundNumber(arena),
                  catalizador: this.doRoundNumber(catalizador),
                  silicato: this.doRoundNumber(silicato),
                  disps: this.tundishDevices,
                },
                type: type,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log("Edit Operation (Operation Result) -> ", result);
                this.dataSourceTundishOperationsSimple.data = [];
                setTimeout(() => {
                  this.dataSourceTundishOperationsSimple.data = result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveTundishCampaignMetadataById(id, option, type) {
    let campaignStart,
      campaignEnd,
      campaignIdentifier,
      campaignName,
      tundishIdentifier;
    this.tundishService
      .getCampaignById(this.collectionNameCampaigns, id)
      .subscribe(
        (data) => {
          let campaign = data.data.findCampaignById;
          campaignStart = campaign.inicio;
          campaignEnd = campaign.fin;
          campaignIdentifier = campaign._id;
          tundishIdentifier = campaign.disp;
          campaignName = campaign.nombre;
          this.dialog
            .open(TundishModalComponent, {
              width: "25%",
              id: "editCampaignDialog",
              data: {
                title: "Campaña de Tundish: Editar",
                id: id,
                content: "",
                option: option,
                metadata: {
                  start: campaignStart,
                  end: campaignEnd,
                  uuid: campaignIdentifier,
                  disp: tundishIdentifier,
                  name: campaignName,
                },
                type: type,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log("Edit Campaign (Operation Result) -> ", result);
                this.dataSourceTundishCampaignsSimple.data = [];
                setTimeout(() => {
                  this.dataSourceTundishCampaignsSimple.data = result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveTundishConsumptionMetadataById(id, option, type) {
    let consumptionStart,
      consumptionTimestamp,
      consumptionIdentifier,
      steelConsumption,
      steeelCastings,
      tundishIdentifier;
    this.tundishService
      .getConsumptionById(this.collectionNameConsumptions, id)
      .subscribe(
        (data) => {
          let consumption = data.data.findConsumptionById;
          consumptionTimestamp = consumption.fecha;
          consumptionIdentifier = consumption._id;
          tundishIdentifier = consumption.disp;
          steelConsumption = consumption.consumo;
          steeelCastings = consumption.coladas;
          this.dialog
            .open(TundishModalComponent, {
              width: "25%",
              id: "editConsumptionDialog",
              data: {
                title: "Conusmo de Tundish: Editar",
                id: id,
                content: "",
                option: option,
                metadata: {
                  timestamp: consumptionTimestamp,
                  uuid: consumptionIdentifier,
                  disp: tundishIdentifier,
                  consumption: steelConsumption,
                  castings: steeelCastings,
                },
                type: type,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log("Edit Consumption (Operation Result) -> ", result);
                this.dataSourceTundishConsumptionsSimple.data = [];
                setTimeout(() => {
                  this.dataSourceTundishConsumptionsSimple.data = result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveAlarmsByCampaign(id, option, type) {
    console.log("Retrieving alarms for campaign -> " + id);
    this.alarmsByTundishCampaign = [];
    this.tundishService
      .getCampaignById(this.collectionNameCampaigns, id)
      .subscribe(
        (data) => {
          console.log("getCampaignById -> ", data);
          let campaign = data.data.findCampaignById;
          let campaignInicio = campaign.inicio;
          let campaignFin = campaign.fin;
          this.incidentsService.getTiposIncidente().subscribe(
            (data) => {
              console.log("getTiposIncidente -> ", data);
              let results = data.data.findTipoDatoEstados;
              let occurrences = [];
              for (let i = 0; i < results.length; i++) {
                let disp = results[i];
                if (disp.nombre == "ColdMag") {
                  for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
                    if (disp.tipoDatoEstado[j].nombre.includes("FALLO")) {
                      let incidente = disp.tipoDatoEstado[j];
                      this.incidentsService
                        .getIncidentOccurrencesBetweenDates(
                          disp.uuid,
                          incidente.uuid,
                          campaignInicio * 1000,
                          campaignFin * 1000
                        )
                        .subscribe(
                          (data) => {
                            console.log("findTimeSerie DISP ->", disp.uuid);
                            console.log(
                              "findTimeSerie TD ->",
                              incidente.nombre
                            );
                            console.log(
                              "findTimeSerie INICIO ->",
                              campaignInicio * 1000
                            );
                            console.log(
                              "findTimeSerie FIN ->",
                              campaignFin * 1000
                            );
                            console.log("findTimeSerie ->", data);
                            let timeserie = [...data.data.findTimeSerie];
                            for (let i = 0; i < timeserie.length; i++) {
                              timeserie[i] = { ...timeserie[i] };
                              timeserie[i]["uuid"] = incidente.uuid;
                              timeserie[i]["alarma"] = incidente.nombre;
                              if (timeserie[i].valor == 1) {
                                occurrences.push(timeserie[i]);
                              }
                            }
                            console.log(
                              "Total Alarms Ocurrences OCCURRENCES -> ",
                              occurrences
                            );
                          },
                          (err) => {
                            console.log(err);
                          }
                        );
                    }
                  }
                }
              }
              this.alarmsByTundishCampaign = occurrences;
            },
            (err) => {
              console.log(err);
            }
          );
          setTimeout(() => {
            console.log("Alarms -> ", this.alarmsByTundishCampaign);
            this.dialog.open(TundishModalComponent, {
              width: "50%",
              data: {
                title: "Alarmas: Listado de Alarmas (Campaign: " + id + ")",
                id: id,
                content: "",
                option: option,
                alarms: this.alarmsByTundishCampaign,
                type: type,
                admin: this.isAdmin,
              },
            });
          }, 5000);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveAlarmsByTundishOperations(id, option, type) {
    this.alarmsByTundishOperations = [];
    this.tundishService
      .getOperationById(this.collectionNameIntervals, id)
      .subscribe(
        (data) => {
          console.log("getOperationById -> ", data);
          let operation = data.data.findIntervalById;
          let operationInicio = operation.inicio;
          let operationFin = operation.fin;
          this.incidentsService.getTiposIncidente().subscribe(
            (data) => {
              console.log("getTiposIncidente -> ", data);
              let results = data.data.findTipoDatoEstados;
              let occurrences = [];
              for (let i = 0; i < results.length; i++) {
                let disp = results[i];
                if (disp.nombre == "ColdMag") {
                  for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
                    if (disp.tipoDatoEstado[j].nombre.includes("FALLO")) {
                      let incidente = disp.tipoDatoEstado[j];
                      this.incidentsService
                        .getIncidentOccurrencesBetweenDates(
                          disp.uuid,
                          incidente.uuid,
                          operationInicio * 1000,
                          operationFin * 1000
                        )
                        .subscribe(
                          (data) => {
                            console.log("findTimeSerie DISP ->", disp.uuid);
                            console.log(
                              "findTimeSerie TD ->",
                              incidente.nombre
                            );
                            console.log(
                              "findTimeSerie INICIO ->",
                              operation.inicio * 1000
                            );
                            console.log(
                              "findTimeSerie FIN ->",
                              operation.fin * 1000
                            );
                            console.log("findTimeSerie ->", data);
                            let timeserie = [...data.data.findTimeSerie];
                            for (let i = 0; i < timeserie.length; i++) {
                              timeserie[i].uuid = incidente.uuid;
                              timeserie[i].alarma = incidente.nombre;
                              if (timeserie[i].valor == 1) {
                                occurrences.push(timeserie[i]);
                              }
                            }
                            console.log(
                              "Total Alarms Ocurrences OCCURRENCES -> ",
                              occurrences
                            );
                          },
                          (err) => {
                            console.log(err);
                          }
                        );
                    }
                  }
                }
              }
              this.alarmsByTundishOperations = occurrences;
            },
            (err) => {
              console.log(err);
            }
          );
          setTimeout(() => {
            console.log("Alarms -> ", this.alarmsByTundishOperations);
            this.dialog.open(TundishModalComponent, {
              width: "50%",
              data: {
                title: "Alarmas: Listado de Alarmas (Operation: " + id + ")",
                id: id,
                content: "",
                option: option,
                alarms: this.alarmsByTundishOperations,
                type: type,
                admin: this.isAdmin,
              },
            });
          }, 5000);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public doFilter = (option, event) => {
    let value = event.target.value;
    let index = event.index;
    // console.log(value);
    if (option == 1)
      this.dataSourceTundishOperationsSimple.filter = value
        .trim()
        .toLocaleLowerCase();
    else
      this.dataSourceTundishCampaignsSimple.filter = value
        .trim()
        .toLocaleLowerCase();
  };

  doGetIndex(uuidTund): number {
    let index = -1;
    for (let i = 0; i < this.tundishDevices.length; i++) {
      if (uuidTund == this.tundishDevices[i].uuid) index = i;
    }
    return index;
  }

  doOpenDialog(type, id, option, disp, inicio, fin) {
    if (type == 0) {
      switch (option) {
        case -1:
          if (id != -1) {
            this.dialog.open(TundishModalComponent, {
              width: "25%",
              data: {
                title: "Cargando información de la Campaña " + id + "...",
                id: id,
                content: "Cargando información...",
                option: option,
                wait: true,
                type: type,
                admin: this.isAdmin,
              },
            });
            setTimeout(() => {
              this.dialog.closeAll();
              this.doRetrieveTundishOperationsByCampaign(
                id,
                disp,
                this.doGetIndex(disp)
              );
              this.currentTundishCampaign = id;
            }, 3000);
          } else {
            console.log("Campaña de Tundish (" + id + "): Añadir");
            this.doRetrieveNextCampaignNameAndOpenModal(id, option, type, disp);
          }
          break;
        case 0:
          console.log("Campaña de Tundish (" + id + "): Editar");
          this.doRetrieveTundishCampaignMetadataById(id, option, type);
          break;
        case 1:
          this.dialog
            .open(TundishModalComponent, {
              id: "removeCampaignDialog",
              data: {
                width: "25%",
                title: "Campaña de Tundish: Eliminar",
                id: id,
                content: "",
                option: option,
                type: type,
                disp: disp,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(result);
                this.dataSourceTundishCampaignsSimple.data = [];
                setTimeout(() => {
                  this.dataSourceTundishCampaignsSimple.data = result;
                }, 3000);
              }
            });
          break;
        case 2:
          this.doRetrieveAlarmsByCampaign(id, option, type);
          break;
        case 3:
          this.dialog.open(TundishModalComponent, {
            width: "50%",
            data: {
              title: "Informe de Producción (Campaña)",
              id: id,
              content: "",
              option: option,
              date: new Date().toLocaleDateString(),
              type: type,
              coldmag: this.colmagDispUuid,
              disp: disp,
              admin: this.isAdmin,
              report: {
                alarms: [],
              },
              operations_chart_data: {}, // Grafica para las Operaciones
              intervals_chart_data: {}, // Grafica para los Intervalos
              pie_data: {}, // Gráfica para las alarmas
            },
          });
          break;
        case 4:
          //this.doRetrieveKPIsByCampaign(id, option, type, disp, inicio, fin);
          this.dialog.open(TundishModalComponent, {
            width: "50%",
            data: {
              title: "KPIs (Campaña)",
              id: id,
              content: "",
              option: option,
              date: new Date().toLocaleDateString(),
              type: type,
              coldmag: this.colmagDispUuid,
              disp: disp,
              inicio: inicio,
              fin: fin,
              admin: this.isAdmin,
              report: {
                alarms: [],
              },
            },
          });
          break;
      }
    } else if (type == 1) {
      switch (option) {
        case 0:
          console.log("Editar Tundish Operation");
          break;
        case 1:
          console.log("Eliminar Tundish Operation");
          break;
        case 2:
          this.dialog.open(TundishModalComponent, {
            width: "50%",
            data: {
              title: "Consumo de Producto: Arena",
              id: id,
              content: "",
              option: option,
              type: type,
              coldmag: this.colmagDispUuid,
              disp: disp,
              admin: this.isAdmin,
              inicio: inicio,
              fin: fin,
              product_graph_data: {},
            },
          });
          break;
        case 3:
          this.dialog.open(TundishModalComponent, {
            width: "50%",
            data: {
              title: "Comsumo de Producto: Silicato",
              id: id,
              content: "",
              option: option,
              type: type,
              coldmag: this.colmagDispUuid,
              disp: disp,
              admin: this.isAdmin,
              inicio: inicio,
              fin: fin,
              product_graph_data: {},
            },
          });
          break;
        case 4:
          this.doRetrieveAlarmsByTundishOperations(id, option, type);
          break;
        case 5:
          this.dialog.open(TundishModalComponent, {
            width: "50%",
            data: {
              title: "Informe de Producción (Operación)",
              id: id,
              content: "",
              option: option,
              type: type,
              admin: this.isAdmin,
              report: {
                alarms: [],
              },
              product_graph_data_sand: {}, // Grafica para la Arena
              product_graph_data_silicate: {}, // Grafica para el Silicato
              product_graph_data_catalyst: {}, // Grafica para el Catalizador
              pie_data: {},
              td: this.collectionNameIntervals,
              disp: disp,
              coldmag: this.colmagDispUuid,
            },
          });
          break;
        case 6:
          this.dialog.open(TundishModalComponent, {
            width: "50%",
            data: {
              title: "Consumo de Producto: Catalizador",
              id: id,
              content: "",
              option: option,
              type: type,
              coldmag: this.colmagDispUuid,
              disp: disp,
              admin: this.isAdmin,
              inicio: inicio,
              fin: fin,
              product_graph_data: {},
            },
          });
          break;
        case 7:
          this.dialog.open(TundishModalComponent, {
            width: "50%",
            data: {
              title: "Intervalos de Trabajo: Operación (" + id + ")",
              id: id,
              content: "",
              option: option,
              type: type,
              coldmag: this.colmagDispUuid,
              disp: disp,
              admin: this.isAdmin,
              inicio: inicio,
              fin: fin,
              td: this.collectionNameSubintervals,
              disps: this.tundishDevices,
            },
          });
          break;
        case 8:
          this.doRetrieveTundishOperationMetadataById(id, option, type);
          break;
      }
    } else if (type == 2) {
      switch (option) {
        case -1:
          if (id != -1) {
            this.dialog.open(TundishModalComponent, {
              width: "25%",
              data: {
                title: "Cargando información de la Campaña " + id + "...",
                id: id,
                content: "Cargando información...",
                option: option,
                wait: true,
                type: type,
                admin: this.isAdmin,
              },
            });
            setTimeout(() => {
              this.dialog.closeAll();
              this.doRetrieveTundishOperationsByCampaign(
                id,
                disp,
                this.doGetIndex(disp)
              );
              this.currentTundishCampaign = id;
            }, 3000);
          } else {
            console.log(
              "Consumo de Acero para la Tundish (" + id + "): Añadir"
            );
            this.dialog
              .open(TundishModalComponent, {
                width: "25%",
                id: "addConsumptionDialog",
                data: {
                  title: "Consumo de Tundish: Añadir",
                  id: id,
                  content: "",
                  option: option,
                  type: type,
                  disp: disp,
                  admin: this.isAdmin,
                },
              })
              .afterClosed()
              .subscribe((result) => {
                if (Array.isArray(result)) {
                  console.log("Add Consumption (Operation Result) -> ", result);
                  this.dataSourceTundishConsumptionsSimple.data = [];
                  setTimeout(() => {
                    this.dataSourceTundishConsumptionsSimple.data = result;
                  }, 3000);
                }
              });
          }
          break;
        case 0:
          console.log(
            "Consumo de Acero para la Tundish (" + disp + "): Editar"
          );
          this.doRetrieveTundishConsumptionMetadataById(id, option, type);
          break;
        case 1:
          this.dialog
            .open(TundishModalComponent, {
              id: "removeConsumptionDialog",
              data: {
                width: "25%",
                title: "Consumo de Tundish: Eliminar",
                id: id,
                content: "",
                option: option,
                type: type,
                disp: disp,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log(
                  "Remove Consumption (Operation Result) -> ",
                  result
                );
                this.dataSourceTundishConsumptionsSimple.data = [];
                setTimeout(() => {
                  this.dataSourceTundishConsumptionsSimple.data = result;
                }, 3000);
              }
            });
          break;
      }
    }
  }

  doRetrieveNextCampaignNameAndOpenModal(id, option, type, uuidTund: string) {
    let campaignName = "CT-";
    this.tundishService
      .getCampaignsByTundish(this.collectionNameCampaigns, uuidTund)
      .subscribe(
        (data) => {
          let campaigns = data.data.findCampaignsByDisp;
          let year = Math.round(Date.now() / 1000);
          campaignName =
            campaignName +
            year +
            "-" +
            (data.data.findCampaignsByDisp.length + 1);
          this.dialog
            .open(TundishModalComponent, {
              width: "25%",
              id: "addCampaignDialog",
              data: {
                title: "Campaña de Tundish: Añadir",
                id: id,
                content: "",
                option: option,
                type: type,
                name: campaignName,
                disp: uuidTund,
                admin: this.isAdmin,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log("Add Campaign (Opperation Result) -> ", result);
                this.dataSourceTundishCampaignsSimple.data = [];
                setTimeout(() => {
                  this.dataSourceTundishCampaignsSimple.data = result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveKPIsByCampaign(id, option, type) {
    this.tundishService
      .getCampaignById(this.collectionNameCampaigns, id)
      .subscribe(
        (data) => {
          let campaign = data.data.findCampaignById;
          this.dialog.open(TundishModalComponent, {
            width: "50%",
            data: {
              title: "KPIs (Campaña)",
              id: id,
              content: "",
              option: option,
              date: new Date().toLocaleDateString(),
              type: type,
              coldmag: this.colmagDispUuid,
              disp: campaign.disp,
              inicio: campaign.inicio,
              fin: campaign.fin,
              admin: this.isAdmin,
              report: {
                alarms: [],
              },
            },
          });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRefresh(disp) {
    console.log("Lets do the view refresh...");
    this.dialog.open(TundishModalComponent, {
      width: "25%",
      data: {
        title: "Cargando información de la " + disp + "...",
        id: -2,
        content: "Cargando información...",
        option: -2,
        wait: true,
        type: 0,
      },
    });
    setTimeout(() => {
      this.doRetrieveTundishCampaignsByTundish(disp);
      this.dialog.closeAll();
    }, 3000);
  }

  doTransformDate(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d.toLocaleString();
    }
  }

  doRoundNumber(number) {
    if (number != null) {
      number = Math.round(number * 100) / 100;
    }
    return number;
  }

  doGetTundishNumber(disp) {
    let tundishNmber = 0;
    for (let i = 0; i < this.tundishDevices.length; i++) {
      let tundish = this.tundishDevices[i];
      if (disp == tundish.uuid) {
        tundishNmber = tundish.nombre.substr(
          tundish.nombre.indexOf(" "),
          tundish.nombre.length
        );
      }
    }
    return tundishNmber;
  }

  doHighlight(row) {
    console.log("Highlighting row -> ", row);
    this.highlightedRows = [];
    this.highlightedRows.push(row);
  }
}
